(function () {
  'use strict';

  function run() {
    var sectionId = window.__termDefinitionSectionId;
    var slugToIdRaw = window.__termDefinitionSlugToId;

    if (!sectionId || !slugToIdRaw || typeof slugToIdRaw !== 'object') {
      return;
    }

    var section = document.querySelector('#shopify-section-' + sectionId);
    if (!section) return;

    var prose = section.querySelector('.article-prose-with-definitions');
    if (!prose) return;

    // Normalize slugs (NFC) for matching
    var slugToId = {};
    try {
      Object.keys(slugToIdRaw).forEach(function (key) {
        var normalized = key.normalize ? key.normalize('NFC') : key;
        slugToId[normalized] = slugToIdRaw[key];
      });
    } catch (e) {
      slugToId = slugToIdRaw;
    }

    function normalizeSlug(s) {
      try {
        return s && s.normalize ? s.normalize('NFC') : s;
      } catch (e) {
        return s;
      }
    }

    // Replace [slug] in text nodes with <span class="term-definition" data-definition-id="...">
    function replaceSlugs() {
      var replaced = false;
      var walker = document.createTreeWalker(
        prose,
        window.NodeFilter ? window.NodeFilter.SHOW_TEXT : 1,
        null,
        false
      );

      var textNode;
      var nodesToProcess = [];

      while ((textNode = walker.nextNode())) {
        if (textNode.nodeValue && textNode.nodeValue.indexOf('[') !== -1) {
          nodesToProcess.push(textNode);
        }
      }

      nodesToProcess.forEach(function (textNode) {
        var text = textNode.nodeValue;
        var re = /\[([^\]]+)\]/g;
        var match;
        var fragments = [];
        var lastIndex = 0;

        while ((match = re.exec(text)) !== null) {
          var slug = match[1];
          var normalizedSlug = normalizeSlug(slug);
          var definitionId = slugToId[normalizedSlug];

          if (definitionId) {
            replaced = true;
            if (lastIndex < match.index) {
              fragments.push(document.createTextNode(text.slice(lastIndex, match.index)));
            }
            var span = document.createElement('span');
            span.className = 'term-definition';
            span.setAttribute('data-definition-id', String(definitionId));
            span.setAttribute('role', 'button');
            span.setAttribute('tabindex', '0');
            span.setAttribute('aria-expanded', 'false');
            span.setAttribute('aria-haspopup', 'true');
            span.textContent = slug;
            fragments.push(span);
            lastIndex = re.lastIndex;
          }
        }

        if (fragments.length > 0) {
          var parent = textNode.parentNode;
          fragments.forEach(function (node) {
            parent.insertBefore(node, textNode);
          });
          parent.removeChild(textNode);
        }
      });

      return replaced;
    }

    // Repeat until no more replacements (handles nested / multiple in same text)
    while (replaceSlugs()) {}

    var popup = null;
    var popupTimeout = null;
    var clickOutsideHandler = null;
    var scrollHandler = null;
    var openByClick = false;

    function hidePopup() {
      if (popup && popup.parentNode) {
        popup.parentNode.removeChild(popup);
        popup = null;
      }
      openByClick = false;
      if (clickOutsideHandler) {
        document.removeEventListener('click', clickOutsideHandler);
        clickOutsideHandler = null;
      }
      if (scrollHandler) {
        document.removeEventListener('scroll', scrollHandler, true);
        scrollHandler = null;
      }
    }

    function positionPopup(termEl, popupEl) {
      var rect = termEl.getBoundingClientRect();
      var viewW = window.innerWidth;
      var viewH = window.innerHeight;
      var popupRect = popupEl.getBoundingClientRect();
      var margin = 8;

      var top = rect.bottom + margin;
      var left = rect.left;

      if (top + popupRect.height > viewH - margin) {
        top = rect.top - popupRect.height - margin;
      }
      if (top < margin) top = margin;

      if (left + popupRect.width > viewW - margin) {
        left = viewW - popupRect.width - margin;
      }
      if (left < margin) left = margin;

      popupEl.style.top = top + 'px';
      popupEl.style.left = left + 'px';
    }

    function showPopup(termEl, definitionId) {
      hidePopup();

      var template = document.getElementById('definition-' + definitionId);
      if (!template || !template.content) return;

      popup = document.createElement('div');
      popup.className = 'term-definition-popup';
      popup.appendChild(template.content.cloneNode(true));

      document.body.appendChild(popup);
      positionPopup(termEl, popup);

      popup.addEventListener('mouseenter', function () {
        if (popupTimeout) {
          clearTimeout(popupTimeout);
          popupTimeout = null;
        }
      });
      popup.addEventListener('mouseleave', function () {
        popupTimeout = setTimeout(function () {
          hidePopup();
          popupTimeout = null;
        }, 150);
      });

      scrollHandler = function () {
        if (popup && termEl.isConnected) {
          positionPopup(termEl, popup);
        }
      };
      document.addEventListener('scroll', scrollHandler, true);
    }

    function handleTermClick(termEl, definitionId) {
      if (openByClick && popup) {
        hidePopup();
        return;
      }
      openByClick = true;
      showPopup(termEl, definitionId);

      clickOutsideHandler = function (e) {
        if (!popup) return;
        if (!popup.contains(e.target) && !termEl.contains(e.target)) {
          var others = document.querySelectorAll('.term-definition');
          var isOtherTerm = false;
          for (var i = 0; i < others.length; i++) {
            if (others[i].contains(e.target)) {
              isOtherTerm = true;
              break;
            }
          }
          if (!isOtherTerm) {
            hidePopup();
          }
        }
      };
      setTimeout(function () {
        document.addEventListener('click', clickOutsideHandler);
      }, 0);
    }

    prose.querySelectorAll('.term-definition').forEach(function (termEl) {
      var definitionId = termEl.getAttribute('data-definition-id');
      if (!definitionId) return;

      termEl.addEventListener('mouseenter', function () {
        if (popupTimeout) clearTimeout(popupTimeout);
        if (openByClick) return;
        popupTimeout = setTimeout(function () {
          showPopup(termEl, definitionId);
          popupTimeout = null;
        }, 100);
      });

      termEl.addEventListener('mouseleave', function () {
        if (popupTimeout) {
          clearTimeout(popupTimeout);
          popupTimeout = null;
        }
        if (openByClick) return;
        popupTimeout = setTimeout(function () {
          hidePopup();
          popupTimeout = null;
        }, 150);
      });

      termEl.addEventListener('click', function (e) {
        e.preventDefault();
        handleTermClick(termEl, definitionId);
      });

      termEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleTermClick(termEl, definitionId);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
